<template >
    <template v-if="option_faqs.type == 1" >
        <div class="single-product__faq">
            <div class="single-product__faq-container">
                <Heading level="2" v-if="data.heading" class="faqs__heading">{{ convertUrlsToLocale(data.heading, baseUrl, locale) }}</Heading>
                <div v-if="data.subtitle" class="faq-single-sub-title">
                    {{ convertUrlsToLocale(data.subtitle, baseUrl, locale) }}
                </div>
                <div
                    v-for="(faq, index) in data.faqs_items"
                    :key="index"
                    class="faqs__item"
                    @click="toggleContentNormal(index)"
                    :class="{ 'active': activeFaqsNormal.includes(index) }"
                >
                    <div class="faqs__item-title" :style="itemStyle"
                        :class="{
                            'faqs__item-hover-bg': option_faqs.style.item.hoverBackground !== '',
                            'faqs__item-hover-color': option_faqs.style.item.hoverColor !== ''
                        }"
                    >
                        <span class="faqs__item-title--text">{{ faq.title }}</span>
                        <span class="faqs__item-title--icon">
                            <span :style="iconStyle" class="faqs__icon faqs__icon--a"></span>
                            <span :style="iconStyle" class="faqs__icon faqs__icon--b"></span>
                        </span>
                    </div>
                    <div class="faqs__item-content"
                        :style="{ height: activeFaqsNormal.includes(index) ? contentHeightsNormal[index] + 'px' : '0', ...contentStyle}"
                    >
                        <div class="faqs__item-text">
                            <div v-html="convertUrlsToLocale(faq.content, baseUrl, locale)"></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </template>
    <template v-else-if="option_faqs.type === 2">

        <div class="faqs">
            <Heading level="2" v-if="data.heading" class="faqs__heading">{{ convertUrlsToLocale(data.heading, baseUrl, locale) }}</Heading>
            <div class="faqs__items">
                <div class="faqs__items--left">
                    <div
                        v-for="(faq, index) in leftColumnFaqs"
                        :key="index"
                        class="faqs__item not-border"
                        @click="toggleContent(index)"
                        :class="{ 'active': activeFaqs.includes(index) }"
                    >
                        <div class="faqs__item-title" :style="itemStyle">
                            <span class="faqs__item-title--text">{{ faq.title }}</span>
                            <span class="faqs__item-title--icon">
                                <span :style="iconStyle" class="faqs__icon faqs__icon--a"></span>
                                <span :style="iconStyle" class="faqs__icon faqs__icon--b"></span>
                            </span>
                        </div>

                        <div class="faqs__item-content"
                            :style="{ height: activeFaqs.includes(index) ? contentHeights[index] + 'px' : '0', ...contentStyle }"
                        >
                            <div class="faqs__item-text">
                                <div v-html="convertUrlsToLocale(faq.content, baseUrl, locale)"></div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="faqs__items--right">
                    <div
                        v-for="(faq, index) in rightColumnFaqs"
                        :key="index"
                        class="faqs__item not-border"
                        @click="toggleContent(index + leftColumnFaqs.length)"
                        :class="{ 'active': activeFaqs.includes(index + leftColumnFaqs.length) }"
                    >
                        <div class="faqs__item-title" :style="itemStyle">
                            <span class="faqs__item-title--text">{{ faq.title }}</span>
                            <span class="faqs__item-title--icon" :style="iconStyle">
                                <span :style="iconStyle" class="faqs__icon faqs__icon--a"></span>
                                <span :style="iconStyle" class="faqs__icon faqs__icon--b"></span>
                            </span>
                        </div>

                        <div class="faqs__item-content"
                            :style="{ height: activeFaqs.includes(index + leftColumnFaqs.length) ? contentHeights[index] + 'px' : '0', ...contentStyle }"
                        >
                            <div class="faqs__item-text">
                                <div v-html="convertUrlsToLocale(faq.content, baseUrl, locale)"></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </template>
    <template v-else>
        <div class="single-product__faq" :class="data?.class_section || 'is_default'"  :id="data?.id_section">
            <div class="single-product__faq-container">
                <Heading level="2" v-if="data.heading" class="faqs__heading">{{ convertUrlsToLocale(data.heading, baseUrl, locale) }}</Heading>
                <div v-if="data.subtitle" class="faq-single-sub-title">
                    {{ convertUrlsToLocale(data.subtitle, baseUrl, locale) }}
                </div>
                <div class="single-product__faqs">
                    <div
                        v-for="(faq, index) in data.faqs_items"
                        :key="index"
                        class="faqs__item"
                        @click="toggleContentNormal(index)"
                        :class="{ 'active': activeFaqsNormal.includes(index) }"
                    >
                        <div class="faqs__item-title" style="height: auto;font-size: 16px;">
                            <span class="faqs__item-title--text">{{ faq.title }}</span>
                            <span class="faqs__item-title--icon">
                                <span style="height: 2.2px;" class="faqs__icon faqs__icon--a faqs__icon_normal"></span>
                                <span class="faqs__icon faqs__icon--b faqs__icon_normal"></span>
                            </span>
                        </div>

                        <div class="faqs__item-content faqs__item-content-normal"
                            :style="{ height: activeFaqsNormal.includes(index) ? contentHeightsNormal[index] + 'px' : '0'}"
                        >
                            <div class="faqs__item-text">
                                <div v-html="convertUrlsToLocale(faq.content, baseUrl, locale)"></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </template>
</template>


<style lang="scss">
    @import "@/assets/scss/components/product/_faqs.scss";
</style>

<script setup lang="ts">
    import {computed} from "vue";
    import Heading from "@/components/Heading.vue";
    const runtimeConfig = useRuntimeConfig();
    const baseUrl = runtimeConfig.public.BASE_URL;
    import { useI18n } from 'vue-i18n';
    const { locale } = useI18n();
    import { convertUrlsToLocale } from '~/utils/getLangUrl';


    const props = defineProps({
        data: {
            type: Object,
            default: () => ({ faqs_items: [], heading: '', is_empty: false })
        },
        option_faqs: {
            type: Object,
            default: () => ({
                type: 1,
                defaultActiveIndex: -1,
                style: {
                    item: {
                        background: '#ad073d',
                        hoverBackground: '',
                        textColor: '#fff',
                        hoverColor: '',
                        fontSize: '16px'
                    },
                    icon: {
                        background: '#fff',
                    },
                    content: {
                        background: 'transparent',
                        textColor: '#88888d',
                        fontSize: '14px'
                    }
                }
            })
        }
    });


    
interface IFAQItem {
    title: string;
    content: string;
}
interface IFAQData {
    heading?: string;
    subtitle?: string;
    faqs_items: IFAQItem[];
    is_empty?: boolean;
    [key: string]: any;
}

type SectionCardData = Record<string, any>;

const normalizeFaqData = (value: unknown): IFAQData => {
    if (!value) {
        return { faqs_items: [], heading: '', is_empty: false };
    }

    if (typeof value === "string") {
        try {
            return JSON.parse(value);
        } catch {
            return { faqs_items: [], heading: '', is_empty: false };
        }
    }

    if (typeof value === "object") {
        return value as IFAQData;
    }

    return { faqs_items: [], heading: '', is_empty: false };
};

    const option_faqs = props.option_faqs;
    const data = computed(() => {
        const source = props.data;

        if (source && typeof source === "object" && "section_data" in source) {
            return normalizeFaqData((source as Record<string, unknown>).section_data);
        }

        return normalizeFaqData(source);
    });

    const itemStyle = computed(() => ({
        background: option_faqs.style.item.background !== '' ? option_faqs.style.item.background : '',
        color: option_faqs.style.item.textColor !== '' ? option_faqs.style.item.textColor : '',
        'font-size': option_faqs.style.item.fontSize !== '' ? option_faqs.style.item.fontSize : '',
    }));

    const iconStyle = computed(() => ({
        background: option_faqs.style.icon.background,
    }));

    const contentStyle = computed(() => ({
        background: option_faqs.style.content.background  !== '' ? option_faqs.style.content.background : '',
        color: option_faqs.style.content.textColor !== '' ? option_faqs.style.content.textColor : '',
        'font-size': option_faqs.style.content.fontSize !== '' ? option_faqs.style.content.fontSize : '',
    }));

    // normal
    const activeFaqsNormal = ref<number[]>([]);
    const contentHeightsNormal = ref<number[]>([]);
    const toggleContentNormal = (index: number) => {
        if (activeFaqsNormal.value.includes(index)) {
            activeFaqsNormal.value = activeFaqsNormal.value.filter(i => i !== index);
        } else {
            activeFaqsNormal.value.push(index);
        }
        setContentHeightsNormal();
    };

    // const setContentHeightsNormal = () => {
    //     const faqElements = document.querySelectorAll<HTMLDivElement>('.faqs__item-content');
    //     console.log('0000',faqElements);
    //     faqElements.forEach((element, index) => {
    //         contentHeightsNormal.value[index] = element.scrollHeight;
    //     });
    // };
    const setContentHeightsNormal = () => {
        const interval = setInterval(() => {
            const faqElements = document.querySelectorAll<HTMLDivElement>('.faqs__item-content');
            if (faqElements.length > 0) {
                faqElements.forEach((element, index) => {
                    contentHeightsNormal.value[index] = element.scrollHeight;
                });
                clearInterval(interval);
            }
        }, 200);
    };

    // two-col
    const activeFaqs = ref<number[]>([]);
    const contentHeights = ref<number[]>([]);
    const leftColumnFaqs = computed(() => data ? data.value.faqs_items.filter((_:any, index: number) => index % 2 === 0) : []);
    const rightColumnFaqs = computed(() => data ? data.value.faqs_items.filter((_:any, index: number) => index % 2 !== 0) : []);

    const toggleContent = (index: number): void => {
        if (activeFaqs.value.includes(index)) {
            activeFaqs.value = activeFaqs.value.filter((i) => i !== index);
        } else {
            activeFaqs.value.push(index);
        }
        calculateHeights();
    };

    const calculateHeights = (): void => {
        const leftElements = document.querySelectorAll<HTMLDivElement>('.faqs__items--left .faqs__item-content');
        const rightElements = document.querySelectorAll<HTMLDivElement>('.faqs__items--right .faqs__item-content');

        contentHeights.value = [];

        leftElements.forEach((leftElement, index) => {
            const rightElement = rightElements[index];
            if (rightElement) {
                const maxHeight = Math.max(leftElement.scrollHeight, rightElement.scrollHeight);
                contentHeights.value[index] = maxHeight;
            }
            else {
                contentHeights.value[index] = leftElement.scrollHeight;
            }
        });
        rightElements.forEach((rightElement, index) => {
            if (!leftElements[index]) {
                const maxHeight = rightElement.scrollHeight;
                contentHeights.value[index] = maxHeight;
            }
        });
    };

    //end two-col

    onMounted(() => {
        if (option_faqs.defaultActiveIndex !== -1) {
            activeFaqsNormal.value.push(option_faqs.defaultActiveIndex);
            activeFaqs.value.push(option_faqs.defaultActiveIndex);
            calculateHeights();
        }
        setTimeout(setContentHeightsNormal, 0);
    })

    watch([() => activeFaqs.value,()=> props.data], () => {
        setTimeout(calculateHeights, 0);
    }, { deep: true });

// if( props.data && props.data.faqs_items ) {
const faqItems = Array.isArray(props.data?.faqs_items) ? props.data.faqs_items : [];

if (faqItems.length > 0) {
    const faqEntities = props.data.faqs_items.map((item: IFAQItem) => ({
        "@type": "Question",
        "name": item.title.replace(/^\d+\.\s*/, ''),
        "acceptedAnswer": {
            "@type": "Answer",
            "text": item.content.replace(/<[^>]*>/g, '')
        }
    }));

    useHead({
        script: [
            {
                type: 'application/ld+json',
                children: JSON.stringify({
                    "@context": "https://schema.org",
                    "@type": "FAQPage",
                    "mainEntity": faqEntities
                })
            }
        ]
    })
}

</script>
